import Survey from "../../components/Survey";

const SurveyPage = () => {
  return (
    <Survey/>
  );
};

export default SurveyPage;
